export function club (state, newClub) {
	const clubIndex = state.clubs.findIndex(club => club.id === newClub.id);

	if (clubIndex >= 0) {
		return state.clubs[clubIndex] = {
			...newClub
		};
	}

	state.clubs.push(newClub);
}
